var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 598,
    viewBox: "0 0 540 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183 712.5C379.613 712.5 539 553.113 539 356.5C539 159.887 379.613 0.5 183 0.5M183 712.5C-13.6134 712.5 -173 553.113 -173 356.5C-173 159.887 -13.6134 0.5 183 0.5M183 712.5V632.529M183 0.5V80.471M183 632.529C335.447 632.529 459.029 508.947 459.029 356.5C459.029 204.053 335.447 80.471 183 80.471M183 632.529C30.5534 632.529 -93.029 508.947 -93.029 356.5C-93.029 204.053 30.5534 80.471 183 80.471M376.478 160.442L327.227 209.694M35.9565 500.964L-13.295 550.215M389.377 356.5C389.377 470.479 296.979 562.877 183 562.877C69.0212 562.877 -23.3768 470.479 -23.3768 356.5C-23.3768 242.521 69.0212 150.123 183 150.123C296.979 150.123 389.377 242.521 389.377 356.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeDesktop);
export default __webpack_public_path__ + "static/media/shapeDesktop.ed3daf2b983af3aa7ec0637c276d3fc8.svg";
export { ForwardRef as ReactComponent };